module.exports = "<td ng-repeat-start=\"col in datagridCtrl.cols\" ng-if=\"$first\">\n\t<input type=\"checkbox\" ng-model=\"item.$checked\" ng-change=\"datagridCtrl.checkItem(item)\"/>\n</td>\n<td ng-repeat-end ng-if=\"!$first\">\n\t<span ng-if=\"(!$last) || (!item.$checked)\">{{item[col.key]}}</span>\n\t\n\t<button ng-if=\"$last && item.$checked\" class=\"btn btn-default\" ng-click=\"item.gender=1-item.gender\">选中的时候可点，变性</button>\n</td>"


/*****************
 ** WEBPACK FOOTER
 ** ./src/modules/demo/partials/datagrid/button-cell.html
 ** module id = 124
 ** module chunks = 1
 **/